import React from 'react';
import ReadMore from 'read-more-less-react';
import 'read-more-less-react/dist/index.css';

function ContentSection({ title, description, image, leftSide }) {
  const imageBox = <img src={image} alt=''/>;
  const descBox = (
    <div>
      <h1 className='base-text medium-text'>{title}</h1>
      <p className='para-text'>
        <ReadMore
          readMoreText={'Read More'}
          readLessText={'Read Less'}
          text={description}
          lines={3}/></p>
    </div>
  );
  return (
    <div className={`content-section ${leftSide ? '' : 'reverse-direction'} centered-content`}>
      <div className={`left-side ${leftSide ? '' : 'description'}`}>
        {leftSide ? imageBox : descBox}
      </div>
      <div className={`right-side  ${!leftSide ? '' : 'description'}`}>
        {!leftSide ? imageBox : descBox}
      </div>
    </div>
  );
}

export default ContentSection;
